import { useState, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import {
  requestCustomerCreate,
  requestCustomerLogin,
  useCustomer,
} from 'lib/customer'
import { useRouter } from 'next/router'

import { Button } from 'components/Global/Button'
import { Radio } from './Radio'
import { Input } from './Input'

const initialFormValues: any = {
  firstName: '',
  lastName: '',
  email: '',
  password: '',
  acceptsMarketing: 'true',
}

export const Signup = () => {
  const [error, setError] = useState<string | null>()
  const { handleSubmit, register, reset } = useForm({
    defaultValues: initialFormValues,
  })
  const { data: customer } = useCustomer()
  const router = useRouter()

  useEffect(() => {
    if (customer !== null) {
      router.push('/account')
      return
    }
  }, [customer])

  const resetForm = () => {
    reset({
      ...initialFormValues,
    })
    setError(null)
  }

  const onSubmit = handleSubmit(async (data, event) => {
    if (!data.acceptsMarketing) {
      setError('You must accept the terms to continue.')
      return
    }

    try {
      const res = await requestCustomerCreate(data)
      await requestCustomerLogin({ email: data.email, password: data.password })
      router.push('/account', undefined, { scroll: false })
    } catch (error) {
      console.log(error)
      if (error.code === 'CUSTOMER_DISABLED') {
        setError(
          'You have already created an account with this email address but it is not yet activated. Follow the link in your email inbox to activate your account.'
        )
      } else {
        setError(error.message)
      }
    }
  })
  return (
    <form className="flex w-full flex-col gap-10" onSubmit={onSubmit}>
      <div className="flex gap-12">
        <Input
          type="text"
          id="firstName"
          label="First Name"
          register={register}
        />
        <Input
          type="text"
          id="lastName"
          label="Last Name"
          register={register}
        />
      </div>
      <Input type="email" id="email" label="Email" register={register} />
      <Input
        type="password"
        id="password"
        label="Password"
        register={register}
      />
      <div className="flex justify-between rounded-6 border-1 border-borderGray px-14 py-26 md:px-20">
        <div className="text-9 uppercase text-midGray md:text-11">
          Updates &amp; Promotions
        </div>
        <div className="flex w-1/2 gap-20 pl-20 text-11 uppercase text-midGray md:gap-60">
          <Radio
            register={register}
            id="acceptsMarketingYes"
            name="acceptsMarketing"
            value="yes"
            label="Yes"
          />
          <Radio
            register={register}
            id="acceptsMarketingNo"
            name="acceptsMarketing"
            value="no"
            label="No"
          />
        </div>
      </div>
      <div className="flex w-full gap-16">
        <Button
          type="button"
          onClick={resetForm}
          className="flex-1 bg-black py-20 text-12 text-white md:py-26 md:text-16 md:hover:!bg-midGray"
        >
          Reset Details
        </Button>
        <Button
          type="submit"
          className="flex-1 bg-yellow py-20 text-12 md:py-26 md:text-16 md:hover:bg-yellow"
        >
          Register
        </Button>
      </div>
      <div className="max-w-[500px] pt-10 text-11 text-midGray">{error}</div>
    </form>
  )
}
